import styled from '@emotion/styled'
import { colors, styles } from 'Constants'

import Link from './Link'

export default styled(Link)`
  ${({ disabled }) => disabled && 'pointer-events: none; opacity: 0.5;'}
  color: ${({ secondary, color }) =>
    secondary ? color || colors.secondary : colors.textOnPrimary};
  background: ${({ secondary, color }) =>
    secondary ? 'transparent' : color || colors.secondary};
  border: 2px solid ${({ color }) => color || colors.secondary};
  padding: ${({ wide }) => (wide ? '12px 36px' : '12px 24px')};
  transition: 0.2s all;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  border-radius: ${styles.borderRadius};

  :hover {
    background-color: ${({ secondary, color }) =>
      secondary ? color || colors.secondary : 'transparent'};
    color: ${({ secondary, color }) =>
      secondary ? colors.textOnPrimary : color || colors.secondary};
  }
`
